import { render, staticRenderFns } from "./lazy_tab_pane.vue?vue&type=template&id=2138d456&"
import script from "./lazy_tab_pane.vue?vue&type=script&lang=js&"
export * from "./lazy_tab_pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports